import React, { FC } from 'react';

import { Box } from '@mantine/core';

import cx from './Container.module.css';

const Container: FC<{
    padding?: 'x' | 'y' | 'xy' | 'none';
    children: React.ReactNode;
}> = ({ padding = 'none', children }) => (
    <Box className={cx.container} data-padding={padding}>
        {children}
    </Box>
);

export { Container };
